<template>
  <a-layout-content class="p-all">
    <a-card :class="getLayoutNonScroll ? 'm-card-long card-monitoring' : 'm-card-compact card-monitoring'">
      <h3 class="m-remove cardtitle" slot="title">{{ labelMenu }}</h3>
      <a-menu
        class="m-menu"
        slot="extra"
        mode="horizontal"
        v-if="!isMobile && subNavigation.length > 0"
      >
        <template v-for="subNav in subNavigation[0].child">
          <a-menu-item :key="subNav.id_menu" v-if="subNav.child.length === 0">
            <router-link
              :to="{
                name: subNav.link_menu,
                param: { id_menu: subNavigation[0].id_menu }
              }"
            >
              <a-icon :type="subNav.icon_menu" />
              {{ subNav.label_menu }}
            </router-link>
          </a-menu-item>
          <a-sub-menu :key="subNav.id_menu" v-else>
            <span slot="title">
              <a-icon :type="subNav.icon_menu" />
              <span class="vertical-submenus">{{ subNav.label_menu }}</span>
            </span>

            <a-menu-item
              v-for="childmenu in subNav.child"
              :key="childmenu.id_menu"
            >
              <router-link :to="{ name: childmenu.link_menu }">
                <a-icon :type="childmenu.icon_menu" />
                <span>{{ childmenu.label_menu }}</span>
              </router-link>
            </a-menu-item>
          </a-sub-menu>
        </template>
      </a-menu>
      <a-popover
        placement="bottomRight"
        slot="extra"
        trigger="click"
        v-model="visible"
        v-else-if="isMobile && subNavigation[0]"
      >
        <a-button type="default" icon="align-right">Menu</a-button>
        <div slot="content">
          <a-menu class="m-menu" slot="extra" mode="inline">
            <template v-for="subNav in subNavigation[0].child">
              <a-menu-item
                :key="subNav.id_menu"
                v-if="subNav.child.length === 0"
              >
                <router-link
                  :to="{
                    name: subNav.link_menu,
                    param: { id_menu: subNavigation[0].id_menu }
                  }"
                >
                  <a-icon :type="subNav.icon_menu" />
                  {{ subNav.label_menu }}
                </router-link>
              </a-menu-item>
              <a-sub-menu class="padding-remove" :key="subNav.id_menu" v-else>
                <span slot="title">
                  <a-icon :type="subNav.icon_menu" />
                  <span class="vertical-submenu">{{ subNav.label_menu }}</span>
                </span>
                <a-menu-item
                  v-for="childmenu in subNav.child"
                  :key="childmenu.id_menu"
                >
                  <router-link :to="{ name: childmenu.link_menu }">
                    <a-icon :type="childmenu.icon_menu" />
                    <span>{{ childmenu.label_menu }}</span>
                  </router-link>
                </a-menu-item>
              </a-sub-menu>
            </template>
          </a-menu>
        </div>
      </a-popover>
      <div :class="getLayoutNonScroll ? 'm-card-long-body': 'm-card-compact-body'">
        <keep-alive include="MonitoringAlokasiPekerjaan">
          <router-view class="p-remove" v-bind="subNavigation"></router-view>
        </keep-alive>
      </div>
    </a-card>
  </a-layout-content>
</template>

<script>
import { mapGetters } from "vuex";
import _ from "lodash";

export default {
  name: "HolderSpesialMenu",
  props: ["spesialFor", "labelMenu"],
  data() {
    return {
      visible: false,
      currentMenu: {},
      prnMenu: {}
    };
  },
  computed: {
    ...mapGetters([
      "getIsSpecialMenus",
      "getAuth",
      "getCuti",
      "getDefaultDateFormat",
      "getStandartFormatDate",
      "getLayoutNonScroll"
    ]),
    subNavigation() {
      let subnav = [];
      if (this.getIsSpecialMenus) {
        subnav = _.filter(
          this.getIsSpecialMenus,
          nav =>
            nav.label_menu
              .toLowerCase()
              .indexOf(this.spesialFor.toLowerCase()) >= 0
        );
      }
      return subnav;
    }
  }
};
</script>

<style scoped lang="less">
.ant-menu-submenu-title {
  padding-left: 100px !important;
  .vertical-submenus{
    padding-right: 15px !important;
  }
}

</style>

<style lang="less">
.card-monitoring {
  height:auto!important;

  .ant-card {
    &-title,
    &-extra {
      padding: 0 !important;
    }
  }
}

.cardtitle{
  color:@primary-color;
  font-weight: bold;
}
</style>
